import { Link } from 'react-router-dom';
import { useShell } from '@/hooks/useShell';
import { routes } from '@/lib/routes';

/**
 * Seconds per card so the row moves at the same linear speed as «Ожидают».
 * Pending chips travel ~3 × 370px in 34s (~33px/s). A science card stride is 260px + 14px gap.
 */
const SCIENCE_SECONDS_PER_CARD = 8.5;

/** Full-width science opportunities marquee — seamless loop, pause on hover (Task 14). */
export const ScienceBand = () => {
  const { shell } = useShell();
  const news = shell?.science_news ?? [];

  const items = news.map((item) => ({
    id: item.id,
    kicker: item.source,
    title: item.title,
    text: item.summary,
    href: item.href || routes.portalSection('news'),
  }));
  const loop = items.length >= 2 ? [...items, ...items] : items;

  return (
    <section className="portal-science-band" aria-label="Наука и исследовательские возможности">
      <div className="portal-science-head">
        <div>
          <span className="eyebrow">Science now</span>
          <h2>Наука и исследовательские возможности</h2>
        </div>
        <Link to={routes.portalSection('news')}>Открыть все →</Link>
      </div>
      {items.length === 0 ? (
        <p className="portal-science-empty">Научные материалы появятся после публикации.</p>
      ) : null}
      <div className="portal-science-marquee">
        <div
          className="portal-science-track"
          data-science-card-count={items.length}
          style={{
            ['--science-marquee-duration' as string]: `${Math.max(items.length, 1) * SCIENCE_SECONDS_PER_CARD}s`,
          }}
        >
          {loop.map((item, index) => (
            <Link
              key={`${item.id}-${index}`}
              to={item.href}
              className="portal-science-card"
              aria-hidden={index >= items.length || undefined}
              tabIndex={index >= items.length ? -1 : undefined}
            >
              <small>{item.kicker}</small>
              <strong>{item.title}</strong>
              <span>{item.text}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
